import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const StyledIcon = styled.img`
  width: 35px;
  height: 40px;
`

export const StyledTitle = styled.p`
  margin-top: 16px;
  margin-bottom: 0;
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.textTitle};
`

export const StyledDesc = styled.div`
  margin-top: 16px;
  margin-bottom: 24px;
  color: ${({ theme }) => theme.colors.textTitle};
  font-size: 14px;
  font-weight: 400;
  line-height: 140%;
  letter-spacing: 0.2px;

  ${({ theme }) => theme.media.sm`
    margin-bottom: 16px;
  `}
`

export const StyledLearnMore = styled.a`
  color: #5f55a9;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.14px;
`
